import React from 'react';
import { Plus, plus } from "lucide-react";
import BodySmallMedium from '../../designSystem/BodySmallMedium';
import Heading6Regular from '../../designSystem/Heading6Regular';
const CustomButton = ({ text, onClick, showLeftIcon = true, icon, width = "124px" }) => {
  const IconComponent = icon || Plus; 
  const dir = document.body.dir;
  const buttonStyle = {
   width: width,
    height: '40px',
    padding: '9px 5px 9px 5px',
    gap: '8px',
    borderRadius: '60px',
    opacity: '0.9',
    backgroundColor: '#007B4E',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    border: 'none',
    cursor: 'pointer',
    flexDirection: dir === 'rtl' ? 'row-reverse' : 'row',
  };

  const iconStyle = {
  width:'20px',
    color: '#fff',
  };


  return (
    <button style={buttonStyle} onClick={onClick}>
    {showLeftIcon && <IconComponent style={iconStyle} />}
    <Heading6Regular text={text} color="#FFFFFF" />
  </button>
  );
};

export default CustomButton;
